import {
  GET_ALL_INVESTMENT_LEADS,
  GET_ALL_INVESTMENT_LEADS_SUCCESS,
  GET_ALL_INVESTMENT_LEADS_FAIL,
  GET_INVESTMENT_LEAD_DETAILS,
  GET_INVESTMENT_LEAD_DETAILS_SUCCESS,
  GET_INVESTMENT_LEAD_DETAILS_FAIL,
  CREATE_INVESTMENT_LEAD,
  CREATE_INVESTMENT_LEAD_SUCCESS,
  CREATE_INVESTMENT_LEAD_FAIL,
  UPDATE_INVESTMENT_LEAD,
  UPDATE_INVESTMENT_LEAD_SUCCESS,
  UPDATE_INVESTMENT_LEAD_FAIL,
  DELETE_INVESTMENT_LEAD,
  DELETE_INVESTMENT_LEAD_SUCCESS,
  DELETE_INVESTMENT_LEAD_FAIL,
} from "./actionTypes"

// Client - This line cannot be edited or removed
export const getAllInvestmentLead = (page, limit, searchText, filters) => ({
  type: GET_ALL_INVESTMENT_LEADS,
  payload: {
    page,
    limit,
    searchText,
    filters,
  },
})

export const getAllInvestmentLeadSuccess = investmentLeads => ({
  type: GET_ALL_INVESTMENT_LEADS_SUCCESS,
  payload: investmentLeads,
})

export const getAllInvestmentLeadFail = error => ({
  type: GET_ALL_INVESTMENT_LEADS_FAIL,
  payload: error,
})

export const getInvestmentLeadDetails = investmentLeadId => ({
  type: GET_INVESTMENT_LEAD_DETAILS,
  payload: investmentLeadId,
})

export const getInvestmentLeadDetailsSuccess = investmentLeadDetails => ({
  type: GET_INVESTMENT_LEAD_DETAILS_SUCCESS,
  payload: investmentLeadDetails,
})

export const getInvestmentLeadDetailsFail = error => ({
  type: GET_INVESTMENT_LEAD_DETAILS_FAIL,
  payload: error,
})

export const createInvestmentLead = (investmentLeads, onCloseClick) => ({
  type: CREATE_INVESTMENT_LEAD,
  payload: { investmentLeads, onCloseClick },
})

export const createInvestmentLeadSuccess = investmentLeads => ({
  type: CREATE_INVESTMENT_LEAD_SUCCESS,
  payload: investmentLeads,
})

export const createInvestmentLeadFail = error => ({
  type: CREATE_INVESTMENT_LEAD_FAIL,
  payload: error,
})

export const updateInvestmentLead = (
  investmentLeads,
  investmentLeadId,
  onCloseClick
) => ({
  type: UPDATE_INVESTMENT_LEAD,
  payload: { investmentLeads, investmentLeadId, onCloseClick },
})

export const updateInvestmentLeadSuccess = investmentLeads => ({
  type: UPDATE_INVESTMENT_LEAD_SUCCESS,
  payload: investmentLeads,
})

export const updateInvestmentLeadFail = error => ({
  type: UPDATE_INVESTMENT_LEAD_FAIL,
  payload: error,
})

export const deleteInvestmentLead = (investmentLeadId, onClose) => ({
  type: DELETE_INVESTMENT_LEAD,
  payload: { investmentLeadId, onClose },
})

export const deleteInvestmentLeadSuccess = investmentLeads => ({
  type: DELETE_INVESTMENT_LEAD_SUCCESS,
  payload: investmentLeads,
})

export const deleteInvestmentLeadFail = error => ({
  type: DELETE_INVESTMENT_LEAD_FAIL,
  payload: error,
})
